import {List, OrderedMap} from 'immutable';
import {Field} from 'records/Search';
/** Below code moved over from FileUploadCallDetailsStore. Used to create a special 'call details'
   object that CallDetailsDialog is capable of understanding
*/

/**
 * A default list of call details / search fields which should be displayed in order for any given call.
 * Notice that this list is used as a backup plan when `SearchFieldsStore.searchFields` is undefined
 * which is a case that could happen if the user opens `/calls/sharedWithMe` on the initial load (but
 * that page is now defunct). In general,
 * this list should not be used to order / rank search fields at all
 * @type {immutable.List}
 */
const defaultSearchFieldNames = List([
  'Caller',
  'Coaching Requested',
  'Date',
  'Duration',
  'Library',
  'Outcome',
  'Call Stage',
  'Company',
  'Title',
  'Contact',
  'Participants',
  'Participant Emails',
  'Id',
  'Meeting Topic',
  'Direction',
]);

const defaultFieldTypes = {
  Duration: 'numeric',
  'Coaching Requested': 'boolean',
  Date: 'datetime',
};

export type CallDetailsMap = OrderedMap<string, {name: string; value: string; type?: string}>;
export default function callDetailsFromDisplayAndSearchFields(
  displayFields: Record<string, string>,
  searchFields?: List<Field>
): CallDetailsMap {
  let callDetails: CallDetailsMap = OrderedMap();

  if (searchFields && !searchFields.isEmpty()) {
    searchFields
      .sortBy(f => f.order)
      .forEach(searchField => {
        const details = searchField.set('value', displayFields[searchField.name]);
        callDetails = callDetails.set(searchField.name, details);
      });
  } else {
    defaultSearchFieldNames.forEach(name => {
      callDetails = callDetails.set(name, {
        name,
        value: displayFields[name],
        type: defaultFieldTypes[name] ?? 'infinite_string',
      });
    });
  }

  return callDetails;
}
